import React from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'


export const CustomEditor = ({ name, handleChange, value, placeholder }) => {
    const modules = {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'align': [] }],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'indent': '-1'}, { 'indent': '+1' }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            ['link', 'image'],
            ['clean']
        ]
    }

    return (
        <ReactQuill
            theme="snow"
            value={value || ''}
            onChange={(content) => handleChange({ target: { name, value: content } })}
            modules={modules}
            placeholder={placeholder}
            style={{ height: '200px', marginBottom: '62px' }}
        />
    )
}